import { render, staticRenderFns } from "./ListarNotificacoes.vue?vue&type=template&id=bc806646"
import script from "./ListarNotificacoes.vue?vue&type=script&lang=js"
export * from "./ListarNotificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports